<template>
  <div>

    <div class="has-text-centered mb-6" v-if="init.name || init.subname">
      <h1 class="title is-3">{{init.name}}</h1>
      <h2 class="subtitle is-5">{{init.subname}}</h2>
    </div>

    <div class="tabs is-centered is-boxed">
      <ul>
        <li :class="{'is-active': tabActive === 'info'}" @click="tabActive = 'info'">
          <a>
            <span class="icon is-small"><font-awesome-icon icon="file-lines" /></span>
            <span>Informazioni</span>
          </a>
        </li>
      </ul>
    </div>

    <transition name="fade" mode="out-in">
      <div v-show="tabActive === 'info'">
          
        <form class="columns is-multiline" @submit.prevent="place._id ? updatePlace() : savePlace()">
          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputSelect
              name="Cliente"
              v-model="place.client"
              :options="clients"
              :loading="waitClients"
              :disabled="waitRecord"
              id="_id"
              track-by="_id"
              :custom-label="$clientName"
              required
            >
              <a class="button is-warning" :href="place.client ? '/clienti/'+place.client._id : 'javascript:void(0)'"><font-awesome-icon icon="user" class="m-0" /></a>
            </InputSelect>
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputText name="Indirizzo" v-model="place.address" />
          </div>
          <div class="column is-6-mobile is-3-tablet is-2-desktop">
            <InputText name="Piano" v-model="place.floor" />
          </div>
          <div class="column is-6-mobile is-3-tablet is-2-desktop">
            <InputText name="Interno" v-model="place.interior" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputText name="CAP" v-model="place.zip" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputText name="Città" v-model="place.city" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-2-desktop">
            <InputText name="Provincia" v-model="place.province" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputSelect
              name="Categoria"
              v-model="place.category"
              :options="['E.1', 'E.2', 'E.3', 'E.4', 'E.5', 'E.6', 'E.7', 'E.8']"
            >
              <a class="button is-warning" title="Legenda categorie edificio" @click="openModalCategory = true"><font-awesome-icon icon="circle-info" class="m-0" /></a>
            </InputSelect>
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <div class="field">
              <label class="label">Posizione</label>
              <div class="control is-flex">
                <button v-show="!showMap" type="button" class="button is-default" @click="showMap = true">Apri mappa</button>
                <div v-if="showMap" style="width: 100%;">
                  <MapGoogle :places="placeList" :draggable="true" @dragend="dragged($event)" ref="map" />
                  <div class="buttons">
                    <button type="button" class="button is-default mt-2" :class="{'is-loading': isGeocoding}" @click="geolocate()">Geolocalizza</button>
                    <button type="button" class="button is-default mt-2" v-if="!place.position && $store.getters.amAdmin" @click="addDefaultPosition()">Aggiungi</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-12 p-0"></div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputTextarea name="Note" v-model="place.notes" />
          </div>

          <div class="column is-full">
            <div class="field is-grouped is-grouped-centered buttons">
              <button @click="goBack()" class="button is-light" type="button"><font-awesome-icon icon="times" />Chiudi</button>
              <button v-if="$store.getters.amAdmin" class="button is-primary" :class="[{'is-loading': disabledSave}]" type='submit' :disabled="disabledSave"><font-awesome-icon icon="save" />Salva</button>
            </div>
          </div>
        </form>

        <Modal :title="'Legenda categorie edificio'" :openModal="openModalCategory" @close="openModalCategory = false" :noAction="true">
          <div>
            <label class="label">Legenda delle Categorie della destinazione dell’edificio</label>
            <div>
              <div><b class="mr-2">E.1</b> Edifici di tutte le tipologie adibiti a residenza e assimilabili;</div>
              <div><b class="mr-2">E.2</b> Edifici adibiti a residenze collettive, a uffici e assimilabili;</div>
              <div><b class="mr-2">E.3</b> Edifici adibiti a ospedali, cliniche o case di cura e assimilabili;</div>
              <div><b class="mr-2">E.4</b> Edifici adibiti ad attività ricreative, associative o di culto e assimilabili;</div>
              <div><b class="mr-2">E.5</b> Edifici adibiti ad attività commerciali e assimilabili;</div>
              <div><b class="mr-2">E.6</b> Edifici adibiti ad attività sportive;</div>
              <div><b class="mr-2">E.7</b> Edifici adibiti ad attività scolastiche a tutti i livelli e assimilabili;</div>
              <div><b class="mr-2">E.8</b> Edifici adibiti ad attività industriali ed artigianali e assimilabili.</div>
            </div>
          </div>
        </Modal>

      </div>
    </transition>

  </div>
</template>

<script>
import utils from '../utils'

export default {
  data() {
    return {
      place: {},
      clients: [],

      tabActive: 'info',

      waitRecord: true,
      waitClients: true,

      showMap: false,

      disabledSave: false,
      isGeocoding: false,

      init: {
        name: false,
        subname: false
      },

      openModalCategory: false
    }
  },

  computed: {
    placeList() {
      if (this.place.position) {
        return [{position: this.place.position}]
      } else {
        return []
      }
    }
  },

  methods: {
    normalizeProvinceCode(value) {
      return (value || '').toString().replace(/[^a-zA-Z]/g, '').toUpperCase().slice(0, 2)
    },

    savePlace() {
      if (!this.checkRequired()) return

      const self = this
      this.disabledSave = true
      this.place.province = this.normalizeProvinceCode(this.place.province)

      this.$http.post('/place', this.place)
      .then(function (response) {
        utils.deleteDraft(self, self.place._timestamp, 'place').then(() => {
          const createdId = response?.data?._id
          if (createdId) {
            self.$router.replace('/luoghi/' + createdId)
          } else {
            self.$router.push('/luoghi')
          }
        })
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.disabledSave = false
      })
    },

    updatePlace() {
      if (!this.checkRequired()) return

      const self = this
      this.disabledSave = true
      this.place.province = this.normalizeProvinceCode(this.place.province)

      this.$http.put('/place/' + this.place._id, this.place)
      .then(function (response) {
        utils.deleteDraft(self, self.place._timestamp, 'place').then(() => {
          self.disabledSave = false
        })
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.disabledSave = false
      })
    },

    checkRequired() {
      if (!this.place.client || !this.place.client._id) {
        alert('Seleziona un cliente!')
        return false
      } else {
        return true
      }
    },

    geolocate() {
      const self = this
      this.isGeocoding = true

      const geocoder = new google.maps.Geocoder()

      setTimeout(function() {
        geocoder
          .geocode({ address: self.place.city + ' ' + self.$fulladdress(self.place) })
          .then((response) => {
            if (response.results[0]) {
              self.place.position = response.results[0].geometry.location
            }
            self.isGeocoding = false
          })
          .catch(error => {
            alert('Errore')
            console.log(error)
            self.isGeocoding = false
          })
      }, 500)
    },

    dragged(event) {
      this.place.position = event
    },

    addDefaultPosition() {
      this.place.position = this.$refs.map.getActualCenter()
    },

    goBack() {
      this.$store.commit('setForm', {name: 'place', value: false})
      this.$router.back()
    }
  },

  watch: {
    place: {
      handler(value) {
        utils.prepareDraft(this, this.place, value, 'place')
      },
      deep: true
    }
  },

  mounted() {
    const self = this

    const id = this.$route.params.id

    if (id) {
      this.$http.get('/place/' + id)
      .then(function (response) {
        self.place = response.data

        self.init.name = self.place.city
        self.init.subname = self.$fulladdress(self.place)

        self.waitRecord = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    } else {
      self.waitRecord = false

      if (this.$store.getters.getForm('place')) {
        self.place = this.$store.getters.getForm('place')
      }
    }

    this.$http.get('/client/filter')
      .then(function (response) {
        if (response && response.data) {
          self.clients = response.data
        }
        self.waitClients = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
  }
}
</script>